
import { createContext, Dispatch, SetStateAction } from "react";

export interface ILocationsContext {
  regions: string[];
  communes: any[];
  selectedRegion: string | null;
  setSelectedRegion: (region: string | null) => void;
  selectedCommune: string | null;
  setSelectedCommune: (commune: string | null) => void;
  selectedCouriers: any[];
  setSelectedCouriers: (couriers: any[]) => void;
  selectedPolygonType: string | null;
  setSelectedPolygonType: (type: string | null) => void;
  selectedPolygon: any | null;
  setSelectedPolygon: (polygon: any | null) => void;
  displayedPolygons: any[];
  setDisplayedPolygons: Dispatch<SetStateAction<any[]>>;
  allPolygons: any[];
  isLoadingRegions: boolean;
  isLoadingCommunes: boolean;
  isLoadingPolygons: boolean;
  setIsLoadingPolygons: (loading: boolean) => void;
  error: string | null;
  country: string;
  refreshPolygons: () => void;
  polygonsRefreshTrigger: number;
  communeCoordinates: { 
    center: { latitude: number; longitude: number };
    area?: any;
    extras?: any;
  } | null;
  communeGeoError: string | null;
}

export const LocationsContext = createContext<ILocationsContext>({} as ILocationsContext);
